import { fmtParede } from './tempoCv';

/**
 * Cor do Pagali Card por bandeira.
 *
 * Vive aqui, e não em cada página, para o cartão ser o mesmo objecto visual no
 * dashboard e na carteira. Devolve as paradas do gradiente Tailwind, para usar
 * com `bg-gradient-to-br`.
 */
export function getCardBrandColor(type?: string): string {
  switch (type?.toUpperCase()) {
    case 'VISA':       return 'from-blue-600 to-blue-800';
    case 'MASTERCARD': return 'from-red-500 to-orange-600';
    case 'VINTI4':     return 'from-green-600 to-green-800';
    default:           return 'from-gray-600 to-gray-800';
  }
}

// Variantes dentro da mesma bandeira — tons aparentados mas distinguíveis à
// primeira vista, para quem tem vários cartões da mesma marca. Strings literais
// completas (não compostas) para o Tailwind as gerar no build.
const BRAND_VARIANTS: Record<string, string[]> = {
  VISA:       ['from-blue-600 to-blue-800', 'from-sky-500 to-indigo-700', 'from-cyan-600 to-blue-900', 'from-indigo-500 to-violet-700'],
  MASTERCARD: ['from-red-500 to-orange-600', 'from-rose-600 to-red-800', 'from-amber-500 to-orange-700', 'from-orange-600 to-red-900'],
  VINTI4:     ['from-green-600 to-green-800', 'from-emerald-500 to-teal-700', 'from-teal-600 to-cyan-800', 'from-lime-600 to-green-900'],
  DEFAULT:    ['from-gray-600 to-gray-800', 'from-slate-500 to-slate-700', 'from-zinc-600 to-neutral-800', 'from-stone-500 to-stone-700'],
};

/**
 * Cor do cartão quando o utilizador pode ter vários: `variant` é a posição do
 * cartão entre os da MESMA bandeira (0 = primeiro, mantém a cor clássica da
 * marca). Com um único cartão é idêntico a getCardBrandColor.
 */
export function getCardColor(type?: string, variant = 0): string {
  const palette = BRAND_VARIANTS[type?.toUpperCase() || ''] || BRAND_VARIANTS.DEFAULT;
  return palette[variant % palette.length];
}

/**
 * Validade a mostrar no cartão.
 *
 * A SISP não devolve a validade do cartão na tokenização (MOP023 §5.4), por isso
 * cai para a data-limite do token e, se nem essa existir, para marcadores.
 */
export function formatCardExpiry(card: {
  expireMonth?: string;
  expireYear?: string;
  limitDate?: string | null;
}): string {
  if (card.expireMonth && card.expireYear) {
    return `${card.expireMonth}/${card.expireYear.slice(-2)}`;
  }
  if (card.limitDate) {
    // limitDate é DATE (só-dia, 00:00Z): mostrar em UTC para não recuar um dia/mês.
    return fmtParede(card.limitDate, { month: '2-digit', year: '2-digit' }, 'pt-PT');
  }
  return '••/••';
}
